import { render } from "./B2bLoginPasswordFormCanal.vue?vue&type=template&id=1cdf60e4&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormCanal.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormCanal.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormCanal.vue?vue&type=style&index=0&id=1cdf60e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdf60e4"]])

export default __exports__